import * as React from 'react'
import { Box, Divider, Grid, IconButton, Link, Typography } from '@mui/material'
import { Facebook, Instagram } from '@mui/icons-material'
import PropTypes from 'prop-types'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

export function AccueilTab({ setSelectedTab, setScrollToShow }) {
  return (
    <>
      <Box
        sx={{
          height: '60vh',
          overflowY: 'auto',
          padding: 1
        }}
      >
        <Grid container spacing={2}>
          {/* Welcome title - takes full width and is centered */}
          <Grid item size={12}>
            <Box display='flex' justifyContent='center'>
              <Typography variant='h3' component='h3' gutterBottom align='center' sx={(theme) => ({ color: theme.palette.title.main })}>
                Bienvenue sur le site de Clair de Scène
              </Typography>
            </Box>
          </Grid>

          <Grid item size={12}>
            <Divider orientation='horizontal' />
          </Grid>

          <Grid item size={{ xs: 12, sm: 3 }}>
            <Typography variant='h4' component='h4' gutterBottom sx={(theme) => ({ color: theme.palette.title.main })}>
              Saison 2026-2027
            </Typography>
          </Grid>
          <Grid item size={{ xs: 12, sm: 9 }}>
            <Typography variant='h6' component='h5'>
              La compagnie Clair de Scène est heureuse de vous dévoiler sa saison 2026-2027 !
            </Typography>
            <Typography paragraph sx={{ mt: 2 }}>
              Une saison qui nous emmène à travers Bruxelles, avec trois rendez-vous, trois lieux et trois univers théâtraux très
              différents!
            </Typography>
            <ul>
              <li>
                Nous avons ouvert la saison le{' '}
                <Box
                  component='strong'
                  sx={(theme) => ({
                    backgroundColor: theme.palette.backgroundColors.selected,
                    px: 0.5,
                    py: 0.25,
                    borderRadius: 1
                  })}
                >
                  25 septembre
                </Box>{' '}
                au Château du Karreveld avec une représentation gratuite de{' '}
                <Link
                  onClick={() => {
                    setScrollToShow('commeEn14')
                    setSelectedTab('2')
                  }}
                >
                  <strong style={{ fontSize: '1.2em' }}>Comme en 14 !</strong>
                </Link>
                , spectacle lauréat du concours{' '}
                <Link href={'https://shop.utick.be/?module=ACTIVITYSERIEDETAILS&pos=BRUXELLONS&s=D854F0F6-EF05-FA47-6273-084BBC03A798'}>
                  Bruxellons
                </Link>{' '}
                !
              </li>
              <li>
                Nous vous retrouverons ensuite sur le campus de l&rsquo;ULB, à la salle Delvaux, les{' '}
                <Box
                  component='strong'
                  sx={(theme) => ({
                    backgroundColor: theme.palette.backgroundColors.selected,
                    px: 0.5,
                    py: 0.25,
                    borderRadius: 1
                  })}
                >
                  6, 7 et 8 novembre
                </Box>
                pour{' '}
                <Link
                  onClick={() => {
                    setScrollToShow('exVoto')
                    setSelectedTab('2')
                  }}
                >
                  <strong style={{ fontSize: '1.2em' }}>Ex-Voto</strong>
                </Link>
              </li>
              <li>
                Enfin, nous clôturerons cette saison au Centre culturel Archipel 19, les{' '}
                <Box
                  component='strong'
                  sx={(theme) => ({
                    backgroundColor: theme.palette.backgroundColors.selected,
                    px: 0.5,
                    py: 0.25,
                    borderRadius: 1
                  })}
                >
                  8, 9, 10 et 11 avril 2027
                </Box>
                , avec{' '}
                <Link
                  onClick={() => {
                    setScrollToShow('repasDesFauves')
                    setSelectedTab('2')
                  }}
                >
                  <strong style={{ fontSize: '1.2em' }}>Le Repas des fauves</strong>
                </Link>
              </li>
            </ul>
            <Typography paragraph>
              Trois spectacles, trois ambiances, et toujours la même envie : partager avec vous le plaisir du théâtre, des histoires et des
              émotions.
            </Typography>
            <Typography>Nous espérons vous retrouver nombreux tout au long de cette nouvelle saison !</Typography>

            <Typography sx={{ mt: 2 }}>
              <PlayArrowIcon /> Intéressés par nos spectacles à venir? Consultez notre page{' '}
              <Link
                onClick={() => {
                  setScrollToShow(null)
                  setSelectedTab('2')
                }}
              >
                Spectacles
              </Link>{' '}
              pour plus de détails!
            </Typography>

            {/* Contact section */}
            <Typography paragraph sx={{ mt: 2 }}>
              Contact :{' '}
              <Link href='mailto:clairdescene@hotmail.com' color='primary'>
                clairdescene@hotmail.com
              </Link>
            </Typography>
            <Typography paragraph>
              Retrouvez-nous aussi sur Instagram :
              <IconButton
                href='https://www.instagram.com/clair.de.scene'
                target='_blank'
                rel='noopener noreferrer'
                color='primary'
                aria-label='Instagram'
              >
                <Instagram />
              </IconButton>{' '}
              et sur Facebook :
              <IconButton
                href='https://www.facebook.com/share/1B2rajxgbv/?mibextid=wwXIfr'
                target='_blank'
                rel='noopener noreferrer'
                color='primary'
                aria-label='Facebook'
              >
                <Facebook />
              </IconButton>
            </Typography>
          </Grid>

          {/* Divider */}
          <Grid item size={12}>
            <Divider />
          </Grid>

          {/* About section */}

          <Grid item size={{ xs: 12, sm: 3 }}>
            <Typography variant='h4' component='h4' gutterBottom sx={(theme) => ({ color: theme.palette.title.main })}>
              Qui sommes-nous ?
            </Typography>
          </Grid>
          <Grid item size={{ xs: 12, sm: 9 }}>
            <Typography>
              <Box
                component='strong'
                sx={(theme) => ({
                  backgroundColor: theme.palette.backgroundColors.selected,
                  px: 0.5,
                  py: 0.25,
                  borderRadius: 1
                })}
              >
                Clair de Scène
              </Box>{' '}
              est une compagnie de théâtre d&lsquo;amateur bruxelloise initiée par Inès Du Four en mai 2024.
            </Typography>
            <Typography>
              Partant de l&lsquo;envie de s&lsquo;immerger davantage dans l&lsquo;univers du théâtre d&lsquo;amateur, avec la complicité
              d&lsquo;Olivier De Prins, notre projet s&lsquo;enracine dans le désir partagé de produire des spectacles de qualité, tout en
              faisant appel à une palette variée de talents. Notre scène est un espace où le plaisir et la passion se conjuguent
              harmonieusement.
            </Typography>
            <Typography>
              Chaque répétition, chaque représentation, est l&lsquo;occasion de partager des moments forts et uniques, où l&lsquo;expression
              artistique et le partage humain se rejoignent pour créer une expérience théâtrale authentique
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

AccueilTab.propTypes = {
  setSelectedTab: PropTypes.func.isRequired,
  setScrollToShow: PropTypes.func.isRequired
}
